import { format, parseJSON, setHours, setMinutes, parse } from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import { Box, Button, Calendar, DateInput, MaskedInput, Text, TextInput } from "grommet";
import React from "react";

export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const DateTimeFormat = "yyyy/MM/dd HH:mm:ss";

export const FormatDateTime = (d: Date, f?: string): string => {
    if (!f) {
        f = DateTimeFormat;
    }
    if (!isNaN(+d)) {
        return format(d, f);
    }
    return "";
};

export const DateTimePicker = ({ value, onChange, disabled, step }: { value: any; onChange: any; disabled?: any; step?: number }) => {
    let [localDate, setLocalDate] = React.useState(new Date());
    let [localDateString, setLocalDateString] = React.useState("");
    let [time, setTime] = React.useState("12:00");

    let [chosen, setChosen] = React.useState(false);

    React.useEffect(() => {
        if (!value || value == "0001-01-01T00:00:00") {
            var now = new Date();
            setTime(format(now, "HH:mm"));
            onChange(now.toISOString());

            var local = utcToZonedTime(now, timeZone);
            setLocalDate(local);
            setLocalDateString(FormatDateTime(local));
        } else {
            setLocalDate(utcToZonedTime(parseJSON(value), timeZone));
            setLocalDateString(FormatDateTime(parseJSON(value)));
            setTime(format(parseJSON(value), "HH:mm"));
        }
    }, [value]);

    React.useEffect(() => {
        setLocalDateString(FormatDateTime(localDate));
    }, [localDate]);

    const setTimeFromString = (time: string) => {
        setTime(time);

        if (/^([0-9]|[01][0-9]|2[0-3]):([0-5][0-9]$|[0-9])$/.test(time)) {
            let [hours, minutes] = time.split(":");

            let newDate = setHours(localDate, parseInt(hours));
            newDate = setMinutes(newDate, parseInt(minutes));

            setLocalDate(newDate);
            onChange(newDate.toISOString());
        }
    };

    const setDateFromString = (date: string) => {
        var d = parse(date, "yyyy-MM-dd", localDate);

        let [hours, minutes] = time.split(":");

        let newDate = setHours(d, parseInt(hours));
        newDate = setMinutes(newDate, parseInt(minutes));

        setLocalDate(newDate);
        onChange(newDate.toISOString());
        setChosen(true);
    };

    return (
        <Box width="small">
            {localDateString && <Calendar size="small" date={localDateString} disabled={disabled ? [["0001-01-01", "9999-12-31"]] : []} onSelect={(date) => setDateFromString(typeof date == "string" ? date : date[0])}></Calendar>}
            <TextInput step={step} type="time" disabled={disabled} value={time} onChange={(e) => setTimeFromString(e.target.value)}></TextInput>
        </Box>
    );
};
